import { MuiF } from '../../../../../../Mui/F/Function/module/MuiF.js';

export const updateOffsetAndLimitOfLocationSearch = ({ offset, limit }) => {
  const search_params = new URLSearchParams(location.search);
  search_params.set('offset', offset);
  search_params.set('limit', limit);
  MuiF.extendHistoryState({ offset, limit }, null, `${location.pathname}?${search_params.toString()}`);
};
